import { replace } from "./history";

export function hasCities(routes) {
    return routes.some(route => route.from.type === 'city' || route.to.type === 'city');
}

export function replaceCityToAirport(routes) {
    const new_routes = [...routes];
    return new_routes.map(route => {
        const from = {...route.from};
        const to = {...route.to};
        if(from.type === 'city') {
            const first_airport = from.first_airport || {}
            from.id = first_airport.id;
            from.type = 'airport';
            from.title = first_airport.title;
            from.icao = first_airport.icao;
        }
        if(to.type === 'city') {
            const first_airport = to.first_airport || {}
            to.id = first_airport.id;
            to.type = 'airport';
            to.title = first_airport.title;
            to.icao = first_airport.icao;
        }
        return {...route, from, to};
    })
}

export function getTimeRounded(time, default_value = '12:00')
{
    if (!time.includes(':')) return default_value

    let [hours, minutes] = time.split(":");
    
    if (!['00', '30'].includes(minutes))
        minutes = parseInt(minutes) >= 30 ? '30' : '00'

    return `${hours}:${minutes}`;
}

export async function queryGetActualSearchData(extended = false) {

    if (!('Qs' in window) || !window.location.search) return null

    const routes_parsed = Qs.parse(window.location.search.replace(/^\?/, ''))
    const routes_short = routes_parsed && typeof routes_parsed === 'object' && Object.keys(routes_parsed).length > 0 && 'r' in routes_parsed ? routes_parsed.r : null
    
    replace(window.location.pathname);

    if (!Array.isArray(routes_short) || routes_short.length === 0) return null

    const routes = routes_short.map(r => {

        const routes = []

        const getTypeTransformed = (type) => {
            switch (type) {
                case 'a': return 'airport';
                case 'c':
                default: return 'city';
            }
        }

        const getDirectionTransformed = (direction, short = false) => {
            const splitted = direction.split(":")
            if (!['c', 'a'].includes(splitted[0])) return false
            if (!splitted[1] && !parseInt(splitted[1])) return false
            return {id: parseInt(splitted[1]), type: short ? splitted[0] : getTypeTransformed(splitted[0])}
        }

        if (r.from && getDirectionTransformed(r.from)) routes.from = getDirectionTransformed(r.from)
        if (r.to && getDirectionTransformed(r.to)) routes.to = getDirectionTransformed(r.to)
        if (r.date) routes.date = r.date
        if (r.time) routes.time = r.time
        if (r.seats) routes.seats = r.seats

        return routes;
    })

    const data = []
    routes_short.map(e => {
        if (e.from) data.push(e.from)
        if (e.to) data.push(e.to)
    })

    if (extended) {
        return await searchAction.getAirportsAndCitiesData(data)
            .then((result) => {
                return routes.map((item) => {
                    if (item.from) item.from = result.find(e => e.id == item.from.id)
                    if (item.to) item.to = result.find(e => e.id == item.to.id)
                    return {from: item.from || {}, to: item.to || {}, seats: item.seats || 1, time: item.time || '12:00', date: getActualDate(item.date)};
                })
            })
            .catch((e) => {
                console.error(e)
                return null
            })
    }

    return routes;
}